import { colors } from '@lmc/common/constants'
import { Button, Icon, IconType } from '@lmc/ui-kit'
import type { CSSProperties } from 'react'
import { useEffect, useState } from 'react'
import styled from 'styled-components'
import { FormInput } from '../../../LEGACY/elemental'

interface EditableTitleProps {
  containerStyles?: CSSProperties
  onSaveTitle: (title: string) => Promise<void> | void
  title: string
  titleStyles?: CSSProperties
}

const handleSave = async (
  onSaveTitle: EditableTitleProps['onSaveTitle'],
  setIsEditable: (value: boolean) => void,
  newTitle: string
) => {
  await onSaveTitle(newTitle)
  setIsEditable(false)
}

export default function EditableTitle({
  containerStyles,
  onSaveTitle,
  title,
  titleStyles
}: EditableTitleProps) {
  const [isEditable, setIsEditable] = useState(false)
  const [newTitle, setNewTitle] = useState(title)

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    setNewTitle(title)
  }, [title])

  return isEditable ? (
    <div style={{ ...titleContainerStyle, ...containerStyles }}>
      <FormInput
        size="default"
        type="text"
        value={newTitle}
        style={editTitleStyle}
        onChange={(e: { target: { value: string } }) => {
          setNewTitle(e.target.value)
        }}
      />
      <Button
        onClick={() => {
          setIsEditable(false)
          setNewTitle(title)
        }}
      >
        Cancel
      </Button>
      <Space />
      <Button
        disabled={newTitle === ''}
        onClick={() => {
          handleSave(onSaveTitle, setIsEditable, newTitle)
        }}
        variant="primary"
      >
        Save
      </Button>
    </div>
  ) : (
    <div style={{ ...titleContainerStyle, ...containerStyles }}>
      <h2 style={titleStyles}>{title}</h2>
      <TitleEditBtn
        onClick={() => {
          setIsEditable(true)
        }}
      >
        <Icon customIcon={IconType.Pencil} size={14} />
      </TitleEditBtn>
    </div>
  )
}

const editTitleStyle: CSSProperties = {
  height: 32,
  marginRight: 10,
  width: '100%'
}

const titleContainerStyle: CSSProperties = {
  display: 'flex'
}

const Space = styled.span`
  display: inline-block;
  width: 10px;
`

const TitleEditBtn = styled(Button)`
  align-self: center;
  background: transparent !important;
  color: ${colors.black} !important;
  height: 30px;
  margin-left: 6px;
  transition: all 0.2s ease;

  &:hover {
    background: ${colors.orange} !important;
    color: ${colors.white} !important;
  }
`
